var csCZ = {
  locale: 'cs_CZ',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Leden', 'Únor', 'Březen', 'duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'listopad', 'prosinec'],
    monthList: ['Leden', 'Únor', 'Březen', 'duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'listopad', 'prosinec'],
    shortDayList: ['Neděle', 'pondělí', 'úterý', 'Středa', 'čtvrtek', 'Pátek', 'sobota'],
    dayList: ['Neděle', 'pondělí', 'úterý', 'Středa', 'čtvrtek', 'Pátek', 'sobota'],
    shortestDayList: ['den', 'jeden', 'dva', 'tři', 'čtyři', 'pět', 'šest']
  },
  'dynamic-date': {
    day: 'dny',
    week: 'týden',
    month: 'měsíc',
    quarter: 'čtvrt',
    year: 'rok',
    before: 'Před ${value}${unit}'
  },
  'auto-complete.empty': 'Žádné údaje',
  'select.selected-count': '${count} položka vybraná',
  'date-time-picker.date': 'Vybrat datum',
  'image-view.zoom-out': 'úzké',
  'input.placeholder': 'Prosím, zadejte',
  'empty.text': 'Žádné údaje',
  'date-picker.cancel': 'zrušit',
  'date-picker.end': 'Koncový čas',
  'cascader.empty': 'Žádné údaje',
  'upload.drop': 'Přetáhněte soubor sem, nebo',
  'color.custom': 'Vlastní barva',
  'cascader.titles': ['úroveň 1', 'úroveň 2', 'Úroveň 3', 'úroveň 4', 'pět úrovní', 'šest úrovní', 'Sedm úrovní', 'úroveň osm'],
  'date-comparison.error-target': 'Zvolte prosím koncový čas porovnání',
  'transfer.empty': 'Žádné relevantní údaje',
  'select.search.placeholder': 'Prosím, zadejte',
  'upload.click': 'Klikněte na nahrát',
  'date-time-picker.placeholder': 'Prosím, zadejte',
  'pager.jump': 'Skoč',
  'tree-select.placeholder': 'Prosím, zadejte',
  'dynamic-date.interval': 'Časová jednotka',
  'modal.cancel': 'zrušit',
  'image-view.rotate': 'otočit',
  'tabs.more': 'více',
  'popover.ok': 'určit',
  'transfer.placeholder': 'Prosím, zadejte',
  'date.month': 'měsíc',
  'select.selected': 'Vybrané',
  'popover.cancel': 'zrušit',
  'image-view.prev': 'Předchozí',
  'table.emptyText': 'Obsah je prázdný',
  'date-time-picker.ok': 'určit',
  'table.filter.confirm': 'určit',
  'tree-select.empty': 'Žádné údaje',
  'dynamic-date.fixed-date': 'Pevný čas',
  'date-comparison.compare': 'kontrast',
  'auto-complete.placeholder': 'Prosím vyberte',
  'time-picker.placeholder': 'Vyberte prosím čas',
  'date.month-first': false,
  'select.clear': 'prázdné',
  'date.year': '${year} rok',
  'date-comparison.yoy': 'Toto období minulý rok',
  'image-view.zoom-to-origin': 'Původní velikost',
  'schedule.title': 'datum/čas',
  'schedule.clear': 'prázdné',
  'date-time-picker.end': 'Vybrat čas konce',
  'dynamic-date.customize': 'vlastní',
  'date-picker.apply': 'aplikace',
  'schedule.selected': 'Vybraný čas',
  'dynamic-date.dynamic-date': 'Dynamický čas',
  'select.placeholder': 'Prosím vyberte',
  'schedule.separator': '、',
  'cascader.search': 'Zadejte prosím hledaný výraz',
  'date-picker.invalid-range': 'Vybraný časový rozsah překročil volitelný rozsah, upravte prosím',
  'dynamic-date.date-preview': 'Náhled času',
  'select.empty': 'Žádné údaje',
  'image-view.next': 'Další',
  'date-time-picker.now': 'tento okamžik',
  'date-time-picker.time': 'Vybrat čas',
  'tree.empty': 'Žádné výsledky nebyly nalezeny',
  'pager.total': '${total} záznamy celkem',
  'image-view.zoom-in': 'zvětšit',
  'date-picker.placeholder': 'Vyberte prosím datum',
  'textarea.placeholder': 'Prosím, zadejte',
  'date.week': 'týden',
  'pager.size': '${count} položky/stránka',
  'modal.ok': 'určit',
  'date-picker.start': 'čas spuštění',
  'table.filter.reset': 'Obnovit',
  'image-view.zoom-to-fit': 'Přizpůsobení',
  'pager.page.placeholder': 'Prosím, zadejte',
  'select.select-all': 'Vybrat vše',
  'list-viewer.empty': 'Žádné údaje',
  'date-comparison.compare-text': 'kontrast',
  'transfer.source': 'Seznam zdrojů',
  'date-time-picker.start': 'Vyberte datum zahájení',
  'date-time-picker-panel.start': 'Datum zahájení',
  'date-time-picker-panel.end': 'Datum konce',
  'date-comparison.error-source': 'Vyberte prosím čas zahájení srovnání',
  'upload.error.overflow-count': 'Maximální počet souborů překročený',
  'date-comparison.placeholder': 'čas spuštění - Koncový čas',
  'time-range-picker.placeholder': 'čas spuštění - Koncový čas',
  'date-comparison.mom': 'Ve srovnání s předchozím obdobím',
  'transfer.target': 'Seznam cílů',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default csCZ;